import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../node_modules/react-vis/dist/style.css';
//import "./app.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from './App';
import { Provider } from "react-redux";
import { createStore } from "redux";
import reducer from "./service/reducer";

const store = createStore(reducer);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
    <App />
    </Provider>
);

